/**
 * Main Application Component
 */

import React from 'react';
import { Admin, CustomRoutes, Resource } from 'react-admin';
import { Route } from 'react-router-dom';
import { StyledEngineProvider } from '@mui/material/styles';
import {
  ContactsRounded as LeadsIcon,
  ApartmentRounded as HotelsIcon,
  AccountTreeRounded as ChainsIcon,
} from '@mui/icons-material';

// Providers
import { authProvider, dataProvider, i18nProvider } from './providers';

// Layout
import { CustomLayout } from './layouts';

// Theme
import lightTheme from './lightTheme';

// Features
import { LeadList, LeadShow, LeadEdit, LeadCreate } from './features/leads';
import { HotelList, HotelEdit, HotelCreate } from './features/hotels';
import { ChainList, ChainEdit, ChainCreate } from './features/chains';
import { CatalogManager } from './features/catalogs';
import { BackupsPage } from './features/backups';

/**
 * Simple Dashboard Component
 */
const Dashboard = () => (
  <div style={{ padding: '20px' }}>
    <h1>Roommatik Contacts</h1>
    <p>Gestión de leads, hoteles, cadenas y newsletters.</p>
  </div>
);

/**
 * Main App Component
 */
const App: React.FC = () => {
  return (
    <StyledEngineProvider injectFirst>
      <Admin
        authProvider={authProvider}
        dataProvider={dataProvider}
        i18nProvider={i18nProvider}
        theme={lightTheme}
        layout={CustomLayout}
        dashboard={Dashboard}
        requireAuth
        disableTelemetry
      >
        <Resource
          name="leads"
          list={LeadList}
          show={LeadShow}
          edit={LeadEdit}
          create={LeadCreate}
          icon={LeadsIcon}
          recordRepresentation={(record) =>
            [record.firstName, record.lastName].filter(Boolean).join(' ')
            || record.email
            || `#${record.id}`}
        />
        <Resource
          name="hotels"
          list={HotelList}
          edit={HotelEdit}
          create={HotelCreate}
          icon={HotelsIcon}
        />
        <Resource
          name="hotel-chains"
          list={ChainList}
          edit={ChainEdit}
          create={ChainCreate}
          icon={ChainsIcon}
        />
        <CustomRoutes>
          <Route path="/catalogs" element={<CatalogManager />} />
          <Route path="/backups" element={<BackupsPage />} />
        </CustomRoutes>
      </Admin>
    </StyledEngineProvider>
  );
};

export default App;
